// Formats a duration in minutes to a human-readable hours string.
// Examples: 720 → "12 hours", 90 → "1.5 hours", 60 → "1 hour", 45 → "0.75 hours"
export function formatDuration(minutes: number): string {
  const hours = minutes / 60
  // Up to 2 decimal places, trailing zeros removed
  const formatted = parseFloat(hours.toFixed(2))
  return `${formatted} ${formatted === 1 ? 'hour' : 'hours'}`
}
